import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import alert from "components/elements/Alert";

import { generateRandomString } from "utils/helper";
import * as services from "../services/positionApi";
import {
  setIsLoading,
  setPosition,
  setPositionOption,
} from "../slices/companySlice";
import { Modal } from "antd";

function usePosition(props) {
  const { onEdit = () => { } } = props;
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("en");
  const isLoading = useSelector((state) => state.company.isLoading);
  const positionList = useSelector((state) => state.company.positionList);
  const possitionOption = useSelector((state) => state.company.possitionOption);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);

  const [createModal, setcreateModal] = useState(false);
  const [editModal, seteditModal] = useState(false);
  const dispatch = useDispatch();

  const modifiedPositionOptions = useMemo(() => {
    const modifiedOptions = possitionOption?.map((opt) => ({
      ...opt,
      label: lang === "en" ? opt?.positionNameEn : opt?.positionName,
      value: opt?.positionId,
    }));

    return modifiedOptions;
  }, [lang, possitionOption]);

  const modifyPosition = (positionList = []) => {
    const map = new Map();
    const result = [];

    // Create a map of positionId to position object
    for (const obj of positionList) {
      obj.children = [];
      map?.set(obj.positionId, obj);
    }

    // Build the nested structure
    for (const obj of positionList) {
      if (obj?.under?.id && map?.has(obj?.under?.id)) {
        const parent = map?.get(obj?.under?.id);
        parent?.children?.push(obj);
      } else {
        result.push(obj);
      }
    }

    return [result[0]];
  };

  const getPosition = useCallback(
    async ({ page = false }) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
        };
        const response = await services.getPosition(values);
        if (page) {
          dispatch(setPosition(modifyPosition(response.data)));
        } else {
          dispatch(setPositionOption(response.data));
        }
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch]
  );

  const createPosition = useCallback(
    async (record, cb = () => { }) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          ...record,
          requestId: generateRandomString(),
          companyId: currentCompany,
          actionId: currentEmployee
        };
        await services.createPosition(values);
        await getPosition({ page: true });
        await getPosition({ page: false });
        setcreateModal(false);
        cb();
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch]
  );

  const deletePosition = useCallback(
    async (positionId) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          positionId: positionId,
        };
        await services.deletePosition(values).then(o => {
          console.log("then", o
          );
        }).catch(error => {

          console.log("catch", error);
          console.error("API Error:", error);

          if (error?.response?.status === 403) {
            Modal.error({
              content: i18n.language == "en" ? "You do not have permission to perform this action." : "คุณไม่มีสิทธิ์ในการดำเนินการนี้",
              okText: t("message.ok"),
            });
          } else if (error?.data?.content?.code === "400") {
            Modal.error({
              content: error?.data?.content?.details[0]?.value,
              okText: t("message.ok"),
            });
          } else {
            seteditModal(false);
          }
        });
      } catch (error) {

      } finally {
        dispatch(setIsLoading(false));
        await getPosition({ page: true });
      }
    },
    [currentCompany, dispatch]
  );


  const updatePosition = useCallback(
    async (record) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          ...record,
          requestId: generateRandomString(),
          companyId: currentCompany,
          statusFlag: "ACTIVE",
          positionId: record.positionId,
        };
        await services.updatePosition(values);
        await getPosition({ page: true });
        await getPosition({ page: false });
        seteditModal(false);
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch]
  );
  useEffect(() => {
    if (currentCompany != null) {
      getPosition({ page: false });
      getPosition({ page: true });
    }
  }, [currentCompany]);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);

  return {
    isLoading,
    positionList,
    createPosition,
    lang,
    modifiedPositionOptions,
    getPosition,
    onEdit,
    setcreateModal,
    createModal,
    deletePosition,
    updatePosition,
    editModal,
    seteditModal,
  };
}

export default usePosition;
